export default __webpack_public_path__ + "img/cfa2c63b6561a1b4d491df3de7e71c47.png";